import { render, staticRenderFns } from "./sidebarnew.vue?vue&type=template&id=1def11c7&scoped=true&"
import script from "./sidebarnew.vue?vue&type=script&lang=js&"
export * from "./sidebarnew.vue?vue&type=script&lang=js&"
import style0 from "./sidebarnew.vue?vue&type=style&index=0&id=1def11c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def11c7",
  null
  
)

export default component.exports